import React from 'react';

var MobileFairnessButton = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: 'pgc-fairness-holder', onClick: onClick },
        React.createElement("i", { className: 'icon-security' })));
};

export { MobileFairnessButton };
